import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [loadingRole, setLoadingRole] = useState(null);

  const handleLogin = async (email, password, role = null) => {
    setLoading(true);
    if (role) setLoadingRole(role);
    setError('');
    
    try {
      await login({ email, password });
      navigate('/dashboard', { replace: true });
    } catch (err) {
      const message = err?.response?.data?.detail || err?.message || 'Erreur de connexion';
      setError(message);
      setLoading(false);
      setLoadingRole(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(formData.email, formData.password);
  };

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex items-center justify-center px-8 py-12">
        <div className="w-full max-w-md">
          <img src="/logo.jpg" alt="PDE Logo" className="h-16 mx-auto mb-8" />
          <h2 className="text-3xl font-heading font-semibold text-[#191D1E] mb-2 text-center">Connexion</h2>
          <p className="text-[#687175] text-center mb-6">Accédez à Gestion des Optimisations</p>

          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm" data-testid="error-message">
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="block text-sm font-medium text-[#191D1E] mb-1">Email</label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-2.5 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#397DFF] focus:border-[#397DFF] transition-all text-sm"
                data-testid="login-email-input"
                placeholder="votre@email.fr"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-[#191D1E] mb-1">Mot de passe</label>
              <input
                type="password"
                required
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                className="w-full px-4 py-2.5 border border-[#BFC6CC] rounded-lg focus:ring-2 focus:ring-[#397DFF] focus:border-[#397DFF] transition-all text-sm"
                data-testid="login-password-input"
                placeholder="Votre mot de passe"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#191D1E] hover:bg-[#0D3A5F] text-white font-medium py-2.5 px-6 rounded-lg transition-colors disabled:opacity-50"
              data-testid="login-submit-button"
            >
              {loading && !loadingRole ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
          
          <p className="mt-6 text-center text-sm text-[#687175]">
            <Link to="/forgot-password" className="text-[#397DFF] font-medium hover:underline" data-testid="forgot-password-link">
              Mot de passe oublié ?
            </Link>
          </p>
          <p className="mt-3 text-center text-sm text-[#687175]">
            Pas encore de compte ?{' '}
            <Link to="/register" className="text-[#397DFF] font-medium hover:underline">
              Créer un compte
            </Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:block flex-1 bg-cover bg-center relative" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1767789082653-e30a047584fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZmFjdG9yeSUyMGVuZXJneXxlbnwwfHx8fDE3Njg3Njk1NzJ8MA&ixlib=rb-4.1.0&q=85)'}}>
        <div className="absolute inset-0 bg-black/60" />
      </div>
    </div>
  );
};

export default Login;
